import React from 'react'
import { useEffect, useState } from 'react';
import { useUserProfile } from '../../helper/UserProfile';
import Gold from '../revalidation/Gold';
import Diamond from '../revalidation/Diamond';
import Platinum from '../revalidation/Platinum';
import '../../stylesheets/dashboard.scss'
import MobileRevalNav from '../mobile/MobileRevalNav';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

function Revalidation() {

  const { profile, loading } = useUserProfile();
  const [tier, setTier] = useState("");    

  useEffect(() => {
  if (profile?.reval_members.membership_tier) {
    setTier(profile.reval_members.membership_tier);
    }
  }, [profile]);


  if (loading || !profile) {
    return <div><FontAwesomeIcon icon={faSpinner} /></div>;
  }


  return (
    <div>
      <div className="mob-only">
        <MobileRevalNav />
      </div>
      {tier === "Gold" ? <Gold /> : tier === "Diamond" ? <Diamond /> : <Platinum />}
    </div>
  )
}

export default Revalidation